/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ConversationsService {
  /**
   * @summary Create Conversation
   * @description Create a new conversation.
   */
  createConversationMessagingConversationsPost: {
    /**
     * @summary Create Conversation
     * @description Create a new conversation.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateConversationMessagingConversationsPostBody,
        CreateConversationMessagingConversationsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateConversationMessagingConversationsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateConversationMessagingConversationsPostBody,
          CreateConversationMessagingConversationsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateConversationMessagingConversationsPostData,
          CreateConversationMessagingConversationsPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateConversationMessagingConversationsPostData,
        CreateConversationMessagingConversationsPostError
      >
    >;
    /**
     * @summary Create Conversation
     * @description Create a new conversation.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateConversationMessagingConversationsPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateConversationMessagingConversationsPostSchema,
      CreateConversationMessagingConversationsPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.conversationsService.createConversationMessagingConversationsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.conversationsService.createConversationMessagingConversationsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateConversationMessagingConversationsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateConversationMessagingConversationsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateConversationMessagingConversationsPostSchema,
        CreateConversationMessagingConversationsPostData,
        CreateConversationMessagingConversationsPostParameters,
        TVariables,
        OperationError<CreateConversationMessagingConversationsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateConversationMessagingConversationsPostData,
      OperationError<CreateConversationMessagingConversationsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.conversationsService.createConversationMessagingConversationsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.conversationsService.createConversationMessagingConversationsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateConversationMessagingConversationsPostBody,
        CreateConversationMessagingConversationsPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateConversationMessagingConversationsPostSchema,
        CreateConversationMessagingConversationsPostData,
        CreateConversationMessagingConversationsPostParameters,
        TVariables,
        OperationError<CreateConversationMessagingConversationsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateConversationMessagingConversationsPostData,
      OperationError<CreateConversationMessagingConversationsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createConversationMessagingConversationsPostTotal = qraft.conversationsService.createConversationMessagingConversationsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createConversationMessagingConversationsPostTotal = qraft.conversationsService.createConversationMessagingConversationsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateConversationMessagingConversationsPostSchema,
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createConversationMessagingConversationsPostPendingMutationVariables = qraft.conversationsService.createConversationMessagingConversationsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createConversationMessagingConversationsPostMutationData = qraft.conversationsService.createConversationMessagingConversationsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateConversationMessagingConversationsPostData,
        OperationError<CreateConversationMessagingConversationsPostError>,
        MutationVariables<
          CreateConversationMessagingConversationsPostBody,
          CreateConversationMessagingConversationsPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateConversationMessagingConversationsPostSchema,
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateConversationMessagingConversationsPostData,
          OperationError<CreateConversationMessagingConversationsPostError>,
          MutationVariables<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Conversation
     * @description Create a new conversation.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateConversationMessagingConversationsPostSchema,
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.conversationsService.createConversationMessagingConversationsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.conversationsService.createConversationMessagingConversationsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateConversationMessagingConversationsPostSchema,
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostError,
            MutationVariables<
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateConversationMessagingConversationsPostSchema,
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateConversationMessagingConversationsPostData,
          CreateConversationMessagingConversationsPostError,
          MutationVariables<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateConversationMessagingConversationsPostSchema;
    types: {
      parameters: CreateConversationMessagingConversationsPostParameters;
      data: CreateConversationMessagingConversationsPostData;
      error: CreateConversationMessagingConversationsPostError;
      body: CreateConversationMessagingConversationsPostBody;
    };
  };
  /**
   * @summary List Conversations
   * @description List conversations with optional filters.
   */
  listConversationsMessagingConversationsGet: {
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ListConversationsMessagingConversationsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListConversationsMessagingConversationsGetSchema,
        options: {
          parameters: ListConversationsMessagingConversationsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >
    ): Promise<
      RequestFnResponse<ListConversationsMessagingConversationsGetData, ListConversationsMessagingConversationsGetError>
    >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void
    ): ServiceOperationQueryKey<
      ListConversationsMessagingConversationsGetSchema,
      ListConversationsMessagingConversationsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.conversationsService.listConversationsMessagingConversationsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.conversationsService.listConversationsMessagingConversationsGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListConversationsMessagingConversationsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.conversationsService.listConversationsMessagingConversationsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.conversationsService.listConversationsMessagingConversationsGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListConversationsMessagingConversationsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListConversationsMessagingConversationsGetSchema,
      ListConversationsMessagingConversationsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.conversationsService.listConversationsMessagingConversationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListConversationsMessagingConversationsGetParameters,
      TQueryFnData = ListConversationsMessagingConversationsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListConversationsMessagingConversationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.conversationsService.listConversationsMessagingConversationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListConversationsMessagingConversationsGetParameters,
      TQueryFnData = ListConversationsMessagingConversationsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListConversationsMessagingConversationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListConversationsMessagingConversationsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listConversationsMessagingConversationsGetTotal = qraft.conversationsService.listConversationsMessagingConversationsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listConversationsMessagingConversationsGetByParametersTotal = qraft.conversationsService.listConversationsMessagingConversationsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listConversationsMessagingConversationsGetResults = qraft.conversationsService.listConversationsMessagingConversationsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listConversationsMessagingConversationsGetCombinedResults = qraft.conversationsService.listConversationsMessagingConversationsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListConversationsMessagingConversationsGetSchema,
          ListConversationsMessagingConversationsGetParameters,
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<ListConversationsMessagingConversationsGetData, ListConversationsMessagingConversationsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ListConversationsMessagingConversationsGetData,
            ListConversationsMessagingConversationsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.conversationsService.listConversationsMessagingConversationsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.conversationsService.listConversationsMessagingConversationsGet.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListConversationsMessagingConversationsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.conversationsService.listConversationsMessagingConversationsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListConversationsMessagingConversationsGetParameters,
      TData = ListConversationsMessagingConversationsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          OperationInfiniteData<TData, ListConversationsMessagingConversationsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListConversationsMessagingConversationsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListConversationsMessagingConversationsGetParameters>,
      OperationError<ListConversationsMessagingConversationsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listConversationsMessagingConversationsGetData = qraft.conversationsService.listConversationsMessagingConversationsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listConversationsMessagingConversationsGetCombinedData = qraft.conversationsService.listConversationsMessagingConversationsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListConversationsMessagingConversationsGetSchema,
          ListConversationsMessagingConversationsGetParameters,
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ListConversationsMessagingConversationsGetData,
              ListConversationsMessagingConversationsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<ListConversationsMessagingConversationsGetData>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<ListConversationsMessagingConversationsGetData>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    fetchInfiniteQuery<TPageParam extends ListConversationsMessagingConversationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        DeepReadonly<TPageParam>,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters
      >
    >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends ListConversationsMessagingConversationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        DeepReadonly<TPageParam>,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends ListConversationsMessagingConversationsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        DeepReadonly<TPageParam>,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters
      >
    >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void)
    ): ListConversationsMessagingConversationsGetData | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void)
    ):
      | OperationInfiniteData<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetParameters
        >
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListConversationsMessagingConversationsGetSchema,
              ListConversationsMessagingConversationsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListConversationsMessagingConversationsGetData,
                    ListConversationsMessagingConversationsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListConversationsMessagingConversationsGetSchema,
              ListConversationsMessagingConversationsGetParameters
            >,
            data: ListConversationsMessagingConversationsGetData | undefined,
          ]
        >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void)
    ):
      | QueryState<ListConversationsMessagingConversationsGetData, ListConversationsMessagingConversationsGetError>
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListConversationsMessagingConversationsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            ListConversationsMessagingConversationsGetData,
            ListConversationsMessagingConversationsGetParameters
          >,
          ListConversationsMessagingConversationsGetError
        >
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
      updater: Updater<
        NoInfer<ListConversationsMessagingConversationsGetData> | undefined,
        NoInfer<DeepReadonly<ListConversationsMessagingConversationsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListConversationsMessagingConversationsGetData | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ListConversationsMessagingConversationsGetData,
              ListConversationsMessagingConversationsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListConversationsMessagingConversationsGetData,
                ListConversationsMessagingConversationsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetParameters
        >
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      updater: Updater<
        NoInfer<ListConversationsMessagingConversationsGetData> | undefined,
        NoInfer<ListConversationsMessagingConversationsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListConversationsMessagingConversationsGetData | undefined>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        TInfinite,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): void;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): number;
    schema: ListConversationsMessagingConversationsGetSchema;
    types: {
      parameters: ListConversationsMessagingConversationsGetParameters;
      data: ListConversationsMessagingConversationsGetData;
      error: ListConversationsMessagingConversationsGetError;
    };
  };
  /**
   * @summary Get Conversation
   * @description Get a conversation with all its messages.
   */
  getConversationMessagingConversationsConversationIdGet: {
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetConversationMessagingConversationsConversationIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetConversationMessagingConversationsConversationIdGetSchema,
        options: {
          parameters: GetConversationMessagingConversationsConversationIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetError
      >
    >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueryKey(
      parameters: DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ): ServiceOperationQueryKey<
      GetConversationMessagingConversationsConversationIdGetSchema,
      GetConversationMessagingConversationsConversationIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetConversationMessagingConversationsConversationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetConversationMessagingConversationsConversationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetConversationMessagingConversationsConversationIdGetSchema,
      GetConversationMessagingConversationsConversationIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useInfiniteQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters,
      TQueryFnData = GetConversationMessagingConversationsConversationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetConversationMessagingConversationsConversationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useInfiniteQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters,
      TQueryFnData = GetConversationMessagingConversationsConversationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetConversationMessagingConversationsConversationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetConversationMessagingConversationsConversationIdGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetTotal = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetByParametersTotal = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             conversation_id: conversationId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetResults = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetCombinedResults = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetConversationMessagingConversationsConversationIdGetSchema,
          GetConversationMessagingConversationsConversationIdGetParameters,
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetConversationMessagingConversationsConversationIdGetData,
            GetConversationMessagingConversationsConversationIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useSuspenseQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetConversationMessagingConversationsConversationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters,
      TData = GetConversationMessagingConversationsConversationIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          OperationInfiniteData<TData, GetConversationMessagingConversationsConversationIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetConversationMessagingConversationsConversationIdGetParameters>,
      OperationError<GetConversationMessagingConversationsConversationIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetData = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetCombinedData = qraft.conversationsService.getConversationMessagingConversationsConversationIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetConversationMessagingConversationsConversationIdGetSchema,
          GetConversationMessagingConversationsConversationIdGetParameters,
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetConversationMessagingConversationsConversationIdGetData,
              GetConversationMessagingConversationsConversationIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<GetConversationMessagingConversationsConversationIdGetData>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<GetConversationMessagingConversationsConversationIdGetData>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    fetchInfiniteQuery<TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters
      >
    >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    prefetchInfiniteQuery<TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    ensureInfiniteQueryData<TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters
      >
    >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ): GetConversationMessagingConversationsConversationIdGetData | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ):
      | OperationInfiniteData<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetConversationMessagingConversationsConversationIdGetSchema,
              GetConversationMessagingConversationsConversationIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetConversationMessagingConversationsConversationIdGetData,
                    GetConversationMessagingConversationsConversationIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetConversationMessagingConversationsConversationIdGetSchema,
              GetConversationMessagingConversationsConversationIdGetParameters
            >,
            data: GetConversationMessagingConversationsConversationIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ):
      | QueryState<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetConversationMessagingConversationsConversationIdGetData,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          GetConversationMessagingConversationsConversationIdGetError
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetConversationMessagingConversationsConversationIdGetData> | undefined,
        NoInfer<DeepReadonly<GetConversationMessagingConversationsConversationIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetConversationMessagingConversationsConversationIdGetData | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetConversationMessagingConversationsConversationIdGetData,
              GetConversationMessagingConversationsConversationIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetConversationMessagingConversationsConversationIdGetData,
                GetConversationMessagingConversationsConversationIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      updater: Updater<
        NoInfer<GetConversationMessagingConversationsConversationIdGetData> | undefined,
        NoInfer<GetConversationMessagingConversationsConversationIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetConversationMessagingConversationsConversationIdGetData | undefined>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        TInfinite,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): void;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): number;
    schema: GetConversationMessagingConversationsConversationIdGetSchema;
    types: {
      parameters: GetConversationMessagingConversationsConversationIdGetParameters;
      data: GetConversationMessagingConversationsConversationIdGetData;
      error: GetConversationMessagingConversationsConversationIdGetError;
    };
  };
}
/**
 * @summary Create Conversation
 * @description Create a new conversation.
 */
export const createConversationMessagingConversationsPost = {
  schema: {
    method: 'post',
    url: '/messaging/conversations/',
    mediaType: ['application/json'],
  },
} as {
  schema: CreateConversationMessagingConversationsPostSchema;
  [QraftServiceOperationsToken]: ConversationsService['createConversationMessagingConversationsPost'];
};
/**
 * @summary List Conversations
 * @description List conversations with optional filters.
 */
export const listConversationsMessagingConversationsGet = {
  schema: {
    method: 'get',
    url: '/messaging/conversations/',
  },
} as {
  schema: ListConversationsMessagingConversationsGetSchema;
  [QraftServiceOperationsToken]: ConversationsService['listConversationsMessagingConversationsGet'];
};
/**
 * @summary Get Conversation
 * @description Get a conversation with all its messages.
 */
export const getConversationMessagingConversationsConversationIdGet = {
  schema: {
    method: 'get',
    url: '/messaging/conversations/{conversation_id}',
  },
} as {
  schema: GetConversationMessagingConversationsConversationIdGetSchema;
  [QraftServiceOperationsToken]: ConversationsService['getConversationMessagingConversationsConversationIdGet'];
};
export const conversationsService = {
  createConversationMessagingConversationsPost,
  listConversationsMessagingConversationsGet,
  getConversationMessagingConversationsConversationIdGet,
} as const;
type CreateConversationMessagingConversationsPostSchema = {
  method: 'post';
  url: '/messaging/conversations/';
  mediaType: ['application/json'];
};
type CreateConversationMessagingConversationsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateConversationMessagingConversationsPostData =
  paths['/messaging/conversations/']['post']['responses']['200']['content']['application/json'];
type CreateConversationMessagingConversationsPostError =
  paths['/messaging/conversations/']['post']['responses']['422']['content']['application/json'];
type CreateConversationMessagingConversationsPostBody =
  paths['/messaging/conversations/']['post']['requestBody']['content']['application/json'];
type ListConversationsMessagingConversationsGetSchema = {
  method: 'get';
  url: '/messaging/conversations/';
};
type ListConversationsMessagingConversationsGetParameters = paths['/messaging/conversations/']['get']['parameters'];
type ListConversationsMessagingConversationsGetData =
  paths['/messaging/conversations/']['get']['responses']['200']['content']['application/json'];
type ListConversationsMessagingConversationsGetError =
  paths['/messaging/conversations/']['get']['responses']['422']['content']['application/json'];
type GetConversationMessagingConversationsConversationIdGetSchema = {
  method: 'get';
  url: '/messaging/conversations/{conversation_id}';
};
type GetConversationMessagingConversationsConversationIdGetParameters =
  paths['/messaging/conversations/{conversation_id}']['get']['parameters'];
type GetConversationMessagingConversationsConversationIdGetData =
  paths['/messaging/conversations/{conversation_id}']['get']['responses']['200']['content']['application/json'];
type GetConversationMessagingConversationsConversationIdGetError =
  paths['/messaging/conversations/{conversation_id}']['get']['responses']['422']['content']['application/json'];
